import { ElectionResponseDto } from '@thro-clients/polyas-connector-api';

import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { translations } from 'locales/i18n';

export const electionValidationSchema = () => {
  const { t } = useTranslation();
  return z
    .object({
      title: z.string().min(1, { message: 'Titel ist erforderlich' }),
      polyasProjectId: z.string().min(1, { message: 'Polyas Projekt ID ist erforderlich' }),
      polyasSharedSecret: z.string().min(1, { message: 'Polyas Shared Secret ist erforderlich' }),
      electionStartDate: z.date({ message: 'Startdatum der Wahl ist erforderlich' }),
      electionEndDate: z.date({ message: 'Enddatum der Wahl ist erforderlich' }),
      visibleStartDate: z.date({ message: 'Startdatum der Sichtbarkeit ist erforderlich' }),
      visibleEndDate: z.date({ message: 'Enddatum der Sichtbarkeit ist erforderlich' }),
      description: z.string().optional()
    })
    .refine(
      data => {
        if (data.electionStartDate && data.electionEndDate) {
          return data.electionStartDate < data.electionEndDate;
        }
        return true;
      },
      { message: t(translations.pages.polyas.validation.case1()), path: ['electionEndDate'] }
    )
    .refine(
      data => {
        if (data.visibleStartDate && data.visibleEndDate) {
          return data.visibleStartDate < data.visibleEndDate;
        }
        return true;
      },
      {
        message: t(translations.pages.polyas.validation.case2()),
        path: ['visibleEndDate']
      }
    )
    .refine(
      data => {
        if (data.electionStartDate && data.visibleStartDate) {
          return data.visibleStartDate <= data.electionStartDate;
        }
        return true;
      },
      {
        message: t(translations.pages.polyas.validation.case3()),
        path: ['visibleStartDate']
      }
    )
    .refine(
      data => {
        if (data.electionEndDate && data.visibleEndDate) {
          return data.visibleEndDate >= data.electionEndDate;
        }
        return true;
      },
      {
        message: t(translations.pages.polyas.validation.case4()),
        path: ['visibleEndDate']
      }
    );
};

export const getElectionInitialValues = (initialElection?: ElectionResponseDto) => {
  return initialElection
    ? {
        title: initialElection.title,
        description: initialElection.description,
        electionStartDate: new Date(initialElection.electionStartDate),
        electionEndDate: new Date(initialElection.electionEndDate),
        visibleStartDate: initialElection?.visibleStartDate
          ? new Date(initialElection?.visibleStartDate)
          : new Date(),
        visibleEndDate: initialElection.visibleEndDate
          ? new Date(initialElection.visibleEndDate)
          : new Date(),
        polyasProjectId: initialElection.polyasElectionHash,
        polyasSharedSecret: undefined
      }
    : {
        title: '',
        description: '',
        electionStartDate: new Date(),
        electionEndDate: new Date(),
        visibleStartDate: new Date(),
        visibleEndDate: new Date(),
        polyasProjectId: '',
        polyasSharedSecret: ''
      };
};
